module.exports = __webpack_public_path__ + "static/media/6.82458c32.PNG";